import { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";

export const getAllRates = async (params?: any): Promise<any[]> => {
    try {
        const data = await getApi('/rates', params);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any[];
    }
}

export const getByIdRates = async (id: number): Promise<any[]> => {
    try {
        const data = await getApi(`/rates/${id}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any[];
    }
}

export const postNewRates = async (body: any): Promise<any> => {
    try {
        const data = await postApi(`/rates`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any[];
    }
}

export const patchRates = async (body: any, id?: number): Promise<any> => {
    try {
        const data = await patchApi(`/rates/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any[];
    }
}

export const deleteRates = async (id: number): Promise<any> => {
    try {
        const data = await deleteApi(`/rates/${id}`, {});
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}